//About.js
import React from "react";
import pfpImage from '../assets/headshot.jpg';

// Company logos
import googlelogo from '../assets/googlelogo.jpg';
import amazonlogo from '../assets/amazonlogo.webp';
import ciscologo from '../assets/ciscologo.png';

// Project logos
import linkmailLogo from '../assets/linkmail-logo.png';
import cscoLogo from '../assets/csco-logo.png';
import jellypodLogo from '../assets/jellypod-logo.png';

// Icons
import { HiOutlineShoppingCart } from "react-icons/hi";
import { HiOutlineEye } from "react-icons/hi";
import { HiOutlineEmojiSad } from "react-icons/hi";
import { HiOutlineChip } from "react-icons/hi";

function About() {

  const experiences = [
    {
      title: "Software Engineer",
      company: "Google",
      description: "Built Generative AI Features for Gmail and Google Chat",
      logo: googlelogo,
    },
    {
      title: "Software Engineer",
      company: "Amazon",
      description: "Developed AI Infrastructure for Amazon.com",
      logo: amazonlogo,
    },
    {
      title: "Software Engineer",
      company: "Cisco",
      description: "Implemented Distributed System Architecture for Networking Solutions",
      logo: ciscologo,
    },
  ];

  const projects = [
    {
      id: 1,
      title: "Linkmail",
      description: "Bridging LinkedIn and Gmail with AI Email Generation",
      icon: linkmailLogo,
      isImage: true,
      link: "https://linkmail.dev/students",
    },
    {
      id: 2,
      title: "CSCO",
      description: "Your Personal Media Board Meets AI",
      icon: cscoLogo,
      isImage: true,
      link: "https://github.com/cs35l-group/csco",
    },
    {
      id: 3,
      title: "UCLA Swipes",
      description: "Helps UCLA Kids Stay On Track With Their Meal Plan",
      icon: <HiOutlineShoppingCart size={34} color="#f5f5f5" />,
      isReactIcon: true,
      link: "https://uclaswipes.com",
    },
    {
      id: 4,
      title: "Jellypod x UCLA",
      description: "UCLA Hub for Jellypod Podcasts For Classes",
      icon: jellypodLogo,
      isImage: true,
      link: "https://github.com/3eif/jelly",
    },
    {
      id: 5,
      title: "Visual Advertisement Detection",
      description: "Web Crawler that Locates Visual Ads and Reads Their Contents",
      icon: <HiOutlineEye size={34} color="#f5f5f5" />,
      isReactIcon: true,
      link: "https://github.com/igupta1/VisualAdvertisementDetection",
    },
    {
      id: 6,
      title: "Drowsiness Detection",
      description: "Real-time detection for Alerting Drowsy Drivers",
      icon: <HiOutlineEmojiSad size={34} color="#f5f5f5" />,
      isReactIcon: true,
      link: "https://github.com/igupta1/DrowsinessDetection",
    },
    {
      id: 7,
      title: "Sensor Fusion",
      description: "Combined Computer Vision, Ultrasonic, Infrared, and Light Sensors",
      icon: <HiOutlineChip size={34} color="#f5f5f5" />,
      isReactIcon: true,
      link: "https://github.com/igupta1/SensorFusion",
    },
  ];

  const handleProjectClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="about-page-combined">
      <div className="about-container">
        {/* Left Column */}
        <div className="about-left-column">
          {/* Profile Section */}
          <section id="home" className="profile-section">
            <div className="profile-header">
              <img src={pfpImage} alt="Ishaan Gupta" className="profile-image" />
              <div className="profile-info">
                <h1>Ishaan Gupta</h1>
                <p>Software Engineer - Problem Solver - Builder
                <br /> <br />
                I focus on turning complex problems into clear, practical solutions — from large-scale systems at Gmail and Amazon.com to tools for everyday users.</p>
              </div>
            </div>
          </section>

          {/* Work Experience Section */}
          <section id="about" className="work-experience-section">
            <h2>Work Experience</h2>
            <div className="experience-list">
              {experiences.map((exp, index) => (
                <div key={index} className="experience-card">
                  <div className="experience-logo">
                    <img src={exp.logo} alt={`${exp.company} logo`} />
                  </div>
                  <div className="experience-details">
                    <h3>{exp.title}</h3>
                    <h4 className="company-name">{exp.company}</h4>
                    {exp.description && <p className="description">{exp.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* Right Column - Projects */}
        <div className="about-right-column">
          <section id="projects" className="projects-section">
            <h2>Personal Projects</h2>
            <div className="projects-list">
              {projects.map((project) => (
                <div
                  key={project.id}
                  className="project-card"
                  onClick={() => handleProjectClick(project.link)}
                >
                  <div className="project-icon">
                    {project.isImage ? (
                      <img src={project.icon} alt={project.title} className="project-icon-img" />
                    ) : (
                      project.icon
                    )}
                  </div>
                  <div className="project-content">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default About;
